export function setLanguage(language) {
  return {
    type: '@settings/SET_LANGUAGE',
    language,
  };
}

export function setInstitution(institution) {
  return {
    type: '@settings/SET_INSTITUTION',
    institution,
  };
}

export function clearSettings() {
  return {
    type: '@settings/CLEAR_SETTINGS',
  };
}
